import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const noOfDropedSurveyAction = createAsyncThunk(
    'no-of-droped-survey',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/no-of-drop-survey?&s_date=${data?.s_date}&e_date=${data?.e_date}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const noOfDropedSurveySlice = createSlice({
    name: 'no-of-droped-survey',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(noOfDropedSurveyAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(noOfDropedSurveyAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(noOfDropedSurveyAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const noOfDropedSurveyReducer = noOfDropedSurveySlice.reducer